import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { BrandedSplash } from "@/components/BrandedSplash";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) return <BrandedSplash label="Checking your session" />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
